import { immerOn } from 'ngrx-immer/store';
import {
  addRegionFilter,
  removeRegionFilter,
  resetRegionFilter,
  setInitialSearchTerm,
  setRegionsFilter,
} from './region.actions';
import { FilterState, Region, RegionFilterState } from '@immosky/types';
import { resetAllFilters } from '../filter.actions';

export const initialRegionState: RegionFilterState = {
  isActive: false,
  regions: [],
  initialSearchTerm: '',
};

export const regionReducers = [
  immerOn(addRegionFilter, (state: FilterState, { region }) => {
    if (!isRegionInList(state, region)) {
      updateRegionFilter(state, state.region.regions.concat(region));
    }
  }),
  immerOn(removeRegionFilter, (state: FilterState, { region }) => {
    updateRegionFilter(
      state,
      state.region.regions.filter((r) => r.id !== region.id)
    );
  }),
  immerOn(resetRegionFilter, resetAllFilters, (state: FilterState) => {
    updateRegionFilter(state, []);
  }),
  immerOn(setRegionsFilter, (state: FilterState, { regions }) => {
    updateRegionFilter(state, regions);
  }),
  immerOn(setInitialSearchTerm, (state: FilterState, { term }) => {
    state.region.initialSearchTerm = term;
  }),
];

function isRegionInList(state: FilterState, region: Region) {
  return state.region.regions.findIndex((r) => r.id === region.id) > -1;
}

export function updateRegionFilter(state: FilterState, regions: Region[]) {
  state.region.regions = regions;
  state.region.isActive = isRegionFilterActive(state.region.regions);
}

export function isRegionFilterActive(regions: Region[]): boolean {
  return regions.length > 0;
}
